export default __webpack_public_path__ + "../staticImages/weisswein2-260.png";